import { render, staticRenderFns } from "./storeFeedbackAttachments.vue?vue&type=template&id=0501ded3"
import script from "./storeFeedbackAttachments.vue?vue&type=script&lang=js"
export * from "./storeFeedbackAttachments.vue?vue&type=script&lang=js"
import style0 from "./storeFeedbackAttachments.vue?vue&type=style&index=0&id=0501ded3&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0501ded3')) {
      api.createRecord('0501ded3', component.options)
    } else {
      api.reload('0501ded3', component.options)
    }
    module.hot.accept("./storeFeedbackAttachments.vue?vue&type=template&id=0501ded3", function () {
      api.rerender('0501ded3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/storeFeedback/storeFeedbackAttachments.vue"
export default component.exports